const AdminUserTypes = {
  LIST_INITING: 'ADMINUSER.LIST_INITING',
  LOAD_USERS: 'ADMINUSER.LOAD_USERS',
  SET_USERS: 'ADMINUSER.SET_USERS',
  LOAD_LUONG_CO_BAN: 'ADMINUSER.LOAD_LUONG_CO_BAN',
  SET_LUONG_CO_BAN: 'ADMINUSER.SET_LUONG_CO_BAN',
  LIST_REQUESTING: 'ADMINUSER.LIST_REQUESTING',
  LIST_SUCCESS: 'ADMINUSER.LIST_SUCCESS',
  LIST_ERROR: 'ADMINUSER.LIST_ERROR',  
    
  ITEM_REQUESTING: 'ADMINUSER.ITEM_REQUESTING',
  ITEM_SUCCESS: 'ADMINUSER.ITEM_SUCCESS',
  ITEM_ERROR: 'ADMINUSER.ITEM_ERROR',  
    
  ITEM_ADD_REQUESTING: 'ADMINUSER.ITEM_ADD_REQUESTING',
  ITEM_ADD_SUCCESS: 'ADMINUSER.ITEM_ADD_SUCCESS',
  ITEM_ADD_ERROR: 'ADMINUSER.ITEM_ADD_ERROR',  
    
  ITEM_UPDATE_REQUESTING: 'ADMINUSER.ITEM_UPDATE_REQUESTING',
  ITEM_UPDATE_SUCCESS: 'ADMINUSER.ITEM_UPDATE_SUCCESS',
  ITEM_UPDATE_ERROR: 'ADMINUSER.ITEM_UPDATE_ERROR',  
    
  ITEM_REMOVE_REQUESTING: 'ADMINUSER.ITEM_REMOVE_REQUESTING',  
  ITEM_REMOVE_SUCCESS:  'ADMINUSER.ITEM_REMOVE_SUCCESS',  
  ITEM_REMOVE_ERROR:  'ADMINUSER.ITEM_REMOVE_ERROR',  

  RESET_DATA: 'ADMINUSER.RESET_DATA',
  SET_MESSAGE: 'ADMINUSER.SET_MESSAGE',
  RESET_ERROR: 'ADMINUSER.RESET_ERROR',
  SET_ERROR: 'ADMINUSER.SET_ERROR',
  SET_FORM_MESSAGES: 'ADMINUSER.SET_FORM_MESSAGES',
  SET_DATA_TO_USER:  'ADMINUSER.SET_DATA_TO_USER',
  SET_DATA_TO_PROPS:  'ADMINUSER.SET_DATA_TO_PROPS',

  LIST_API: '/api/v1/admin/list_users', 
  ITEM_API: '/api/v1/admin/user_details',
  ITEM_ADD_API: '/api/v1/admin/user_add',
  ITEM_UPDATE_API: '/api/v1/admin/user_update',
  ITEM_REMOVE_API: '/api/v1/admin/user_delete',
  LOAD_USERS_API: '/api/v1/admin/list_users_by_store',
  LOAD_LUONG_CO_BAN_API: '/api/v1/bacluong/getListLuongCoBan'
};

export default AdminUserTypes;


// WEBPACK FOOTER //
// ./src/views/Admin/AdminUser/constants.js